<template>
    <v-bottom-navigation background-color="primary" app grow dark :height="(isIos) ? 75 : 65" class="align-start d-flex d-md-none" :class="{ 'pt-3': isIos, 'pt-4': !isIos }">
        <template v-if="isLoggedIn">
            <v-btn :to="{name: 'Home'}" exact plain :ripple="false">
                <span>Dashboard</span>
                <v-icon>fal fa-home-alt</v-icon>
            </v-btn>

            <v-btn :to="{name: 'Profiles'}" exact plain :ripple="false">
                <span>Profielen</span>
                <v-icon>fal fa-search</v-icon>
            </v-btn>

            <v-btn :to="{name: 'Organisations'}" exact plain :ripple="false">
                <span>Dienstverleners</span>
                <v-icon>fal fa-building</v-icon>
            </v-btn>

            <v-btn :to="{name: 'Account'}" exact plain :ripple="false">
                <span>Account</span>
                <v-icon>fal fa-user</v-icon>
            </v-btn>
        </template>

        <!-- Uitgelogde bezoekers (diensten) zien alleen het publieke dienstverleneraanbod en de mogelijkheid om in te loggen. -->
        <template v-else>
            <v-btn :to="{name: 'Organisations'}" exact plain :ripple="false">
                <span>Dienstverleners</span>
                <v-icon>fal fa-building</v-icon>
            </v-btn>

            <v-btn :to="{name: 'SignIn'}" exact plain :ripple="false">
                <span>Inloggen</span>
                <v-icon>fal fa-sign-in</v-icon>
            </v-btn>
        </template>
    </v-bottom-navigation>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "BottomNavigation",
    computed: {
        ...mapState({
            isLoggedIn: state => state.auth.isLoggedIn,
        }),
        isIos() {
            var agent = window.navigator.userAgent,
            start = agent.indexOf('OS');

            if( ( agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1 ) && start > -1 ){
                return true;
            }

            return false;
        }
    }
}
</script>

<style>
.v-bottom-navigation .v-btn {
    background-color: transparent !important;
    height: auto !important;
}
.v-bottom-navigation .v-btn .v-btn__content > span {
    margin-top: 5px;
    transition: 0.2s font-size ease-in-out;
    font-size: 12px;
}
.v-bottom-navigation .v-btn.v-btn--active .v-btn__content > span {
    font-size: 14px;
}
</style>
